import firebase from 'firebase';

const BACKEND_URL = 'https://asl-stem-backend.herokuapp.com';

export default class BackendHelpers {
  // Adds a new term to the database
  static addTerm = (termData) => {
    firebase.database().ref('/terms').push().set(termData);
  };

  // Set term in database - termData must contain a field "Name"
  static updateTerm = (termData, key) => {
    return new Promise((resolve, error) => {
      firebase
        .database()
        .ref('/terms/' + key)
        .set(termData)
        .then(() => resolve(key))
        .catch((err) => error(err));
    });
  };

  // Updates entire cross links array for a term
  static setCrossReferences = (termId, arr) => {
    firebase
      .database()
      .ref('/terms/' + termId + '/References')
      .set(arr);
  };

  // Adds video to database - it should already have been uploaded to YouTube
  static addVideo = (videoData) => {
    firebase
      .auth()
      .currentUser.getIdToken()
      .then((token) => {
        fetch(BACKEND_URL + '/video', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ token, videoData }),
        });
      });
  };

  // Deletes video with a certain id
  static deleteVideo = (videoId) => {
    return new Promise((resolve, error) => {
      firebase
        .auth()
        .currentUser.getIdToken()
        .then((token) => {
          fetch(BACKEND_URL + '/video', {
            method: 'DELETE',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ token, videoId }),
          })
            .then(() => resolve())
            .catch((err) => error(err));
        });
    });
  };

  // Moves video with id to be under new term
  static moveVideo = (videoId, newTerm) => {
    return new Promise((resolve, error) => {
      firebase
        .auth()
        .currentUser.getIdToken()
        .then((token) => {
          fetch(BACKEND_URL + '/moveVideo', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ token, videoId, newTerm }),
          })
            .then(() => resolve())
            .catch((err) => error(err));
        });
    });
  };

  // Gets auth token
  static getAuthToken = (userId) => {
    return new Promise((resolve, err) => {
      fetch(BACKEND_URL + '/authToken', {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ userId }),
      })
        .then((result) => {
          result.json().then((access_token) => {
            resolve(access_token);
          });
        })
        .catch((error) => {
          err(error);
        });
    });
  };

  // Get All Users
  static getAllUsers = () => {
    return new Promise((resolve, error) => {
      firebase
        .database()
        .ref('/users')
        .once('value')
        .then((snapshot) => {
          resolve(snapshot.val());
        })
        .catch((e) => error(e));
    });
  };

  // Get Level of specific user
  static getUserLevel = (userId) => {
    return new Promise((resolve, reject) => {
      firebase
        .auth()
        .currentUser.getIdToken()
        .then((token) => {
          let url = new URL(BACKEND_URL + '/userLevel');
          url.searchParams.append('token', token);
          url.searchParams.append('userId', userId);
          fetch(url)
            .then((result) => {
              result.text().then((level) => {
                resolve(level);
              });
            })
            .catch((error) => reject(error));
        })
        .catch((error) => reject(error));
    });
  };

  // Set Level of specific user
  static setUserLevel = (userId, state) => {
    alert(state);
    return new Promise((resolve, err) => {
      firebase
        .auth()
        .currentUser.getIdToken()
        .then((token) => {
          fetch(BACKEND_URL + '/userLevel', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ token, userId, state }),
          })
            .then(() => resolve())
            .catch((error) => err(error));
        })
        .catch((error) => err(error));
    });
  };

  // Gets username list
  static getUserNames = () => {
    return new Promise((resolve, err) => {
      fetch(BACKEND_URL + '/usernames')
        .then((result) => {
          result.json().then((usernames) => {
            resolve(usernames);
          });
        })
        .catch((error) => {
          err(error);
        });
    });
  };

  // Admin username route (requires admin credentials or else fails)
  static getUidUserNames = () => {
    return new Promise((resolve, error) => {
      firebase
        .database()
        .ref('/usernames')
        .once('value')
        .then((snapshot) => {
          resolve(snapshot.val());
        })
        .catch((e) => error(e));
    });
  };

  // Create account in database and set username with backend
  static createAccount = (uid, username, fullname, email) => {
    return new Promise((res) => {
      firebase
        .database()
        .ref('/users/' + uid)
        .set({
          username,
          fullname,
          email,
          level: 'USER',
        });
      firebase
        .auth()
        .currentUser.getIdToken()
        .then((token) => {
          fetch(BACKEND_URL + '/usernames', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ token, username }),
          }).then(() => res());
        });
    });
  };

  // Get term requests
  static getTermRequests = () => {
    return new Promise((resolve, error) => {
      firebase
        .database()
        .ref('/requests')
        .once('value')
        .then((snapshot) => {
          resolve(snapshot.val());
        })
        .catch((e) => error(e));
    });
  };

  // Add term request
  static addTermRequest = (term, parent, details, email) => {
    firebase
      .database()
      .ref('/requests')
      .push()
      .set({ term, details, email, parent: parent ? parent : '' });
  };
  // Deletes term request
  static deleteTermRequest = (id) => {
    firebase
      .database()
      .ref('/requests/' + id)
      .remove();
  };

  // Sets video rating
  static setRating = (videoId, rating, uid) => {
    console.log(videoId);
    firebase
      .database()
      .ref('/users/' + uid + '/ratings/' + videoId)
      .set(rating);
    firebase
      .auth()
      .currentUser.getIdToken()
      .then((token) => {
        fetch(BACKEND_URL + '/rateVideo', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ token, videoId, rating }),
        });
      });
  };
}
